import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { PoBreadcrumb, PoDialogService, PoDynamicFormField, PoLookupColumn, PoNotificationService, PoSelectComponent, PoSelectOption, PoTableColumn } from '@po-ui/ng-components';
import { ProcessoCadastro, defaultProcessoCadastro } from 'src/app/administrativo/interface/processo-cadastro';
import { ProcessoPreCadastroCliente, ProcessoPreCadastroClienteDto, defaultProcessoPreCadastroCliente } from 'src/app/administrativo/interface/processo-pre-cadastro-cliente';
import { ProcessoCadastroService } from 'src/app/administrativo/service/processo-cadastro';
import { MunicipioIBGE } from 'src/app/interface/municpio-ibge';
import { AuthService } from 'src/app/service/auth.service';
import { BaseService } from 'src/app/service/base-service';
import { CEPService } from 'src/app/service/cep-service';
import { ClienteService } from 'src/app/service/cliente-service';
import { MunicipioIBGEService } from 'src/app/service/municipio-ibge-service';
import { UtilService } from 'src/app/service/util';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-pre-cadastro-cliente-crud',
  templateUrl: './pre-cadastro-cliente-crud.component.html',
  styleUrls: ['./pre-cadastro-cliente-crud.component.css']
})
export class PreCadastroClienteCrudComponent implements OnInit {

  patternPadraoTotvs: string = environment.patternPadraoTotvs;
  preCliente: ProcessoPreCadastroCliente = defaultProcessoPreCadastroCliente();
  processoCadastro: ProcessoCadastro = defaultProcessoCadastro();

  usuarioLogado: string = '';
  usuarioSolicitante: boolean = false;
  usuarioEngenharia: boolean = false;
  usuarioControladoria: boolean = false;
  usuarioDiretoria: boolean = false;

  bloqueiaDadosSolicitante: boolean = true;
  liberaAvancarProcesso: boolean = true;

  tabelaHistorico: Array<any> = [];
  historico: string = '';
  urgente: string = 'N';
  listaEstado: Array<PoSelectOption> = this.utilService.getListaEstados();

  listaContaContabil: Array<PoSelectOption>;

  urlApiProtheus: string = environment.urlApiProtheus;

  breadcrumb: PoBreadcrumb = {
    items: [
      {label: 'Home', action: this.goHome.bind(this)},
      {label: 'Lista', action: this.goLista.bind(this)},
      {label: 'Pré-cadastro Cliente'},
    ],
  };

  advancedMunicipioIBGEFilters: Array<PoDynamicFormField>;
  columnsMunicipioIBGEFilters: Array<PoLookupColumn>;
  fieldFormaterMunicipioIBGEFilters: ((value: MunicipioIBGE) => string);

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private poNotificationService: PoNotificationService,
    private poDialogService: PoDialogService,
    private utilService: UtilService,
    private authService: AuthService,
    private baseService: BaseService,
    public cepService: CEPService,
    public municipioIBGEService: MunicipioIBGEService,
    private processoCadastroService: ProcessoCadastroService,
    private clienteService: ClienteService,

  ) {

    this.advancedMunicipioIBGEFilters = this.municipioIBGEService.getAdvancedFilter();
    this.columnsMunicipioIBGEFilters = this.municipioIBGEService.getColumnsFilter();
    this.fieldFormaterMunicipioIBGEFilters = this.municipioIBGEService.getFieldFormater;

    this.listaContaContabil = [
      {value: '112111', label: '112111 - Clientes Nacionais'},
      {value: '112112', label: '112112 - Clientes Estrangeiros'},
      {value: '112113', label: '112113 - Clientes Comerciais Exportadoras'},
      {value: '112114', label: '112114 - Clientes Pessoa Física'},
    ]
  }

  @ViewChild('poSelectEst', {static: false}) poSelectEst!: PoSelectComponent;
  @ViewChild('formPrincipal', { static: true }) formPrincipal!: NgForm;

  ngOnInit(): void {

    this.usuarioLogado = localStorage.getItem('CUSRID') || '';

    this.activatedRoute.params.subscribe({
      next : (params) => {
        if ('NPROCESSOCODIGO' in params && 'NCODIGO' in params) {
          this.loadDados(params.NPROCESSOCODIGO, params.NCODIGO);
        } else {
          this.bloqueiaDadosSolicitante = false;
        }
      }, error: () => {
        this.bloqueiaDadosSolicitante = false;
      }
    })



  }

  loadDados(NPROCESSOCODIGO: number, NCODIGO: number):void{

    this.processoCadastroService.getProcCadastro(NPROCESSOCODIGO).subscribe({
      next: (ret) => {

        this.processoCadastro = ret;

        this.urgente = ret.CURGENTE;

        this.usuarioSolicitante = (this.processoCadastro.CCODIGOUSUARIOPROTHEUS === this.usuarioLogado);

        this.authService.validaPrivilegio(['PORTAL_ADMINISTRADOR', 'PO_PRECAD_ENGENHARIA']).then((temPermissao) => {
          this.usuarioEngenharia = temPermissao;

          this.authService.validaPrivilegio(['PORTAL_ADMINISTRADOR', 'PO_PRECAD_CONTROLADORIA']).then((temPermissao) => {
            this.usuarioControladoria = temPermissao;

            this.authService.validaPrivilegio(['PORTAL_ADMINISTRADOR', 'PO_PRECAD_DIRETORIA']).then((temPermissao) => {
              this.usuarioDiretoria = temPermissao;

              this.liberaTela();
            });
          });
        });
      }
      ,error: () => {
        this.goLista();
      }
    })

    this.processoCadastroService.getProcCadastroPreCliente(NCODIGO).subscribe({
      next: (ret) => {
        this.municipioIBGEService.estado = ret.CA1EST;
        this.preCliente = ret;
      }
      ,error: () => {
        this.goLista();
      }
    })

    this.processoCadastroService.getProcCadastroHistoricoLista(NPROCESSOCODIGO).subscribe({
      next: (historico) => {
        this.tabelaHistorico = historico.items;
      }
    })
  }

  liberaTela():void{
    if ( ['2','4','6'].includes(this.processoCadastro.CSTATUS) && this.usuarioSolicitante){
      this.bloqueiaDadosSolicitante = false;
    } else if (this.processoCadastro.CSTATUS === '1' && this.usuarioEngenharia){
      this.bloqueiaDadosSolicitante = false;
    } else if (this.processoCadastro.CSTATUS === '3' && this.usuarioControladoria){
      this.bloqueiaDadosSolicitante = false;
    } else if (this.processoCadastro.CSTATUS === '5' && this.usuarioDiretoria){
      this.bloqueiaDadosSolicitante = false;
    } else {
      this.liberaAvancarProcesso = false;
    }
  }

  gravarDados(decisao: string):void{

    const dados: ProcessoPreCadastroClienteDto = {
      CURGENTE: this.urgente,
      CLIENTE: this.preCliente,
      CHISTORICO: this.historico,
      CDECISAO: decisao,
    };

    this.processoCadastroService.postProcCadastroPreCliente(dados).subscribe({
      next: (ret) => {
        this.goLista();
      }
    })

  }

  confirmarTela():void{

    if (this.formPrincipal.valid){
      let texto = '';
      if (this.processoCadastro.NCODIGO <= 0){
        texto = 'Deseja incluir a solicitação de cadastro de cliente?'
      } else {
        texto = 'Deseja aprovar a solicitação de cadastro de cliente?'
      }

      this.poDialogService.confirm({
        title: 'Avançar processo',
        message: texto,
        confirm: () =>{
          this.gravarDados('A');
        }
      })
    } else {
      this.utilService.showErrosFomulario(this.formPrincipal,document);
    }

  }

  cancelarRecusarTela():void{
    if (this.processoCadastro.CSTATUS){
      if (this.historico){
        this.poDialogService.confirm({
          title: 'Recusar processo',
          message: 'Deseja Recusar o cadastro deste Cliente?',
          confirm: () =>{
            this.gravarDados('R');
          }
        })
      } else {
        this.poNotificationService.warning({
          message: 'Informe uma observação para poder recusar o cadastro do cliente.',
          duration: 5000
        })
      }
    } else {
      this.poDialogService.confirm({
        title: 'Cancelar Solicitação',
        message: 'Deseja sair da tela e cancelar a solicitação de cadastro de cliente?',
        confirm: () =>{
          this.goLista();
        }
      })
    }
  }

  alteraCep(event: Event | string = '') {
    let cep = '';

    if (typeof event === 'string') {
      cep = event as string;

    } else if (event instanceof Event) {
      cep = (event.target as HTMLInputElement).value;

    } else {
      return;
    }

    const cepLimpo = cep.replace(/[^0-9]+/g, "");

    if (this.preCliente.CA1TIPO !== 'X' && cepLimpo.length === 8){
      this.cepService.getObjectByValue(cepLimpo).subscribe(
        (res) => {
          if (('cep' in res)) {
            this.preCliente.CA1END      = `${res.logradouro.toUpperCase()}, `;
            this.preCliente.CA1BAIRRO   = res.bairro.toUpperCase();
            this.preCliente.CA1EST      = res.uf;
            this.preCliente.CA1COD_MUN  = res.ibge.substring(2, 7);
            this.preCliente.CA1ESTADO   = '';

            this.municipioIBGEService.estado = res.uf;

            this.poSelectEst.disabled = true;
          } else {
            this.dadosCepLimpo();
          }
        },
        (err)=> {
          this.dadosCepLimpo();
        }
      );
    }
  }

  dadosCepLimpo(): void {
    this.preCliente.CA1END      = '';
    this.preCliente.CA1BAIRRO   = '';
    this.preCliente.CA1ESTADO   = '';
    this.preCliente.CA1COD_MUN  = '';
    this.preCliente.CA1MUN      = '';
    this.preCliente.CA1EST      = ' ';

    this.municipioIBGEService.estado = '';

    this.poSelectEst.disabled = false;
  }

  municipioIBGESelecionado(row: MunicipioIBGE) {
    this.preCliente.CA1MUN = row.CCC2MUN;
  }

  validarCIP():void{

    if (this.preCliente.CA1CGC.length === 11 || this.preCliente.CA1CGC.length === 14){

      this.baseService.getValidaCGC(this.preCliente.CA1CGC).subscribe({
        next: (ret) => {

          if (this.preCliente.CA1CGC !== '00000000000000'){
            this.clienteService.getClienteLista({MODELO: 'B', CA1CGC: this.preCliente.CA1CGC, PRECAD: 'S'}).subscribe({
              next: (lista) => {
                if (lista.items.length > 0){
                  this.poDialogService.alert({
                    title: 'Identificação de Cliente',
                    message: `O CNPJ/CPF (${this.preCliente.CA1CGC}) informado já está cadastrado para o cliente ${lista.items[0].CA1COD} ${lista.items[0].CA1NOME}. Deseja trocar o valor informado?`,
                  })
                  this.preCliente.CA1CGC = '';
                } else {

                }
              }
            })
          }



          if (this.preCliente.CA1CGC.length===14){
            this.baseService.getDadosCNPJ(this.preCliente.CA1CGC).subscribe( {
              next: (dados) => {
                this.preCliente.CA1NOME = dados.nome;
                this.preCliente.CA1NREDUZ = dados.fantasia.substring(0,20);
                this.preCliente.CA1CEP = dados.cep.replace(/[^0-9]+/g, "");

                const telefone = dados.telefone.split("/")

                if (telefone.length){
                  const telefone1 = telefone[0].replace(/[^0-9]+/g, "");
                  this.preCliente.CA1DDD = telefone1.substring(0,2);
                  this.preCliente.CA1TEL = telefone1.substring(2,100);
                }
                this.alteraCep()
              }
            })
          }
        }
      });
      if (this.preCliente.CA1CGC === '00000000000000'){
        this.preCliente.CA1EST = 'EX';
        this.preCliente.CA1TIPO = 'X';
        this.preCliente.CA1PESSOA = 'J';
        this.preCliente.CA1INSCR = 'ISENTO';
        this.preCliente.CA1COD_MUN = '99999';
      }else if (this.preCliente.CA1CGC.length===11){
        this.preCliente.CA1PESSOA = 'F';
        this.preCliente.CA1TIPO = '';
        this.preCliente.CA1CODPAIS = '01058';
        this.preCliente.CA1PAIS = '105';
      }else if (this.preCliente.CA1CGC.length===14){
        this.preCliente.CA1PESSOA = 'J';
        this.preCliente.CA1TIPO = '';
        this.preCliente.CA1CODPAIS = '01058';
        this.preCliente.CA1PAIS = '105';
      }
    } else {
      this.poNotificationService.warning(
        {
          message: 'Campo deve conter 11 ou 14 caracteres.',
          duration: 5000,
        }
      );
    }
  }

  selecionarEstado(): void {
    this.municipioIBGEService.estado = this.preCliente.CA1EST;
  }

  alteraTipo(value: string):void{
    if (this.preCliente.CA1TIPO.trim() === value) return;

    if (this.preCliente.CA1TIPO === 'X'){
      this.preCliente.CA1EST = 'EX';
      this.preCliente.CA1PESSOA = 'J';
      this.preCliente.CA1INSCR = 'ISENTO';
      this.preCliente.CA1COD_MUN = '99999';

      this.poSelectEst.disabled = true;
    } else {
      this.preCliente.CA1CODPAIS  = '01058';
      this.preCliente.CA1PAIS     = '105';
      this.preCliente.CA1ESTADO   = '';
      this.preCliente.CA1MUN      = '';
      this.preCliente.CA1CEP      = '';
      this.preCliente.CA1EST      = ' ';

      this.poSelectEst.disabled = false;
    }
  }

  goLista(): void {
    this.router.navigateByUrl('administrativo/pre-cadastro/cliente/lista');
  }

  goHome(): void {
    this.router.navigateByUrl('');
  }

  public readonly tabelaHistoricoColunas: Array<PoTableColumn> = [
    {property: 'CCODIGOUSUARIOPROTHEUS_NOME', label: 'Usuário'   , width: '15%', visible: true},
    {property: 'DDATA'                      , label: 'Data'      , width: '10%', visible: true, type: 'date', format: 'dd/MM/Y'},
    {property: 'CHORA'                      , label: 'Hora'      , width: '10%', visible: true},
    {property: 'CSTATUS' , width: '12%' , label: 'Status' , visible: true, type: 'label' ,
      labels: [
        { value: '1', color: 'color-03', label: 'Engenharia'},
        { value: '2', color: 'color-05', label: 'Engenharia Negado'},
        { value: '3', color: 'color-08', label: 'Controladoria'},
        { value: '4', color: 'color-07', label: 'Controladoria Negado'},
        { value: '5', color: 'color-01', label: 'Diretoria'},
        { value: '6', color: 'color-02', label: 'Diretoria Negado'},
        { value: '7', color: 'color-10', label: 'Finalizado'},
        { value: 'A', color: 'color-12', label: 'Cancelado'},
      ]
    },
    {property: 'COBSERVACAO'                , label: 'Observação', width: '55%', visible: true},
  ]

}
